import React from 'react';
import { ClassAssembly5B2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly5B2026 />;
  };
  
  export default ClassAssemblyPage;